/* eslint-disable sonarjs/no-duplicate-string */
define((require, exports, module) => {
    'use strict';

    const $ = require('jQuery');
    const BLayer = require('toolkit/b-layer/b-layer');

    const BillingBalanceReplenished = BLayer.extend(
        'billing-balance-replenished',
        {
            templateBlock: 'b-layer',
            renderMode: 'replace',
            service: false,
            canHide: true,
            inner: true,

            defaults: {
                mods: ['billing-balance-replenished'],
                block: 'b-panel',
                params: {
                    close: true,
                    mods: ['service', 'popup', 'billing-balance-replenished'],
                    view: 'billing-balance-replenished',
                    content: {}, // this.data
                    footer: {
                        btn: [],
                    },
                },
            },

            data: {
                optional: false,
            },

            _getFooterButtons() {
                // Если регистрироваться необязательно,
                // удалим кнопку "Пройти дорегистрацию"
                // и сделаем главной кнопку "Закрыть".
                return this.data.optional
                    ? [
                          {
                              name: 'close',
                              text: 'Закрыть',
                              mods: ['main'],
                          },
                      ]
                    : [
                          {
                              name: 'register',
                              text: 'Пройти дорегистрацию',
                              mods: ['main'],
                          },
                          {
                              name: 'close',
                              text: 'Закрыть',
                          },
                      ];
            },

            /**
             * overrides BControlsGroup.fn._initDropdowns()
             */
            _initDropdowns() {},

            /**
             * @returns {Object}
             */
            getData() {
                return $.extend(
                    true,
                    {},
                    this.defaults,
                    {
                        params: {
                            content: this.data,
                            footer: {
                                btn: this._getFooterButtons(),
                            },
                        },
                    },
                    this.data,
                );
            },
        },
    );

    module.exports = BillingBalanceReplenished;
});
